import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { CustomerState } from "./types";
import{ CustomerSchema } from '@/models/customer_schema';

const state: CustomerState = {
  customers: [] as CustomerSchema[],
  selected: {} as CustomerSchema
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
